// extracted by mini-css-extract-plugin
module.exports = {"block":"Footer_block__1L6bN","inner":"Footer_inner__1oJaY"};